<div class="container">
  <div class="page-container">
    <div class="title-bar">
      <div class="dashboard-title">Payment Dashboard</div>
    </div>

    <mat-divider class="divider-top"></mat-divider>

    <div class="subtitle-row">
      <div class="left-section">
        <div class="total-sites">{{ startIndex }} - {{ endIndex }} of {{ totalItems }} Total Payment Periods</div>
        <div class="pagination-select">
          <mat-form-field>
            <mat-label>Page Size</mat-label>
            <mat-select (selectionChange)="goToPage(1)" [(value)]="paginationTotal" class="select-filter">
              <mat-option [value]="20">20 Per page</mat-option>
              <mat-option [value]="40">40 Per page</mat-option>
              <mat-option [value]="100">100 Per page</mat-option>
              <mat-option [value]="99999">Show All</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <ng-container *ngIf="currentUser.isLimitedAdmin && adminBuyers.length > 1">
          <mat-form-field class="buyer-filter-select">
            <mat-label>Buyer Filter</mat-label>
            <mat-select (selectionChange)="getItemByBuyerId($event, 'buyer_id')">
              <mat-option>--</mat-option>
              <mat-option *ngFor="let adminBuyer of adminBuyers" [value]="adminBuyer.id">
                {{ adminBuyer.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
        <div>
          <mat-checkbox
            class="include-all-checkbox"
            [checked]="includeAllSubmitted"
            (change)="toggleIncludeAllSubmitted()">
            Include All Submitted
          </mat-checkbox>
        </div>
      </div>
      <div class="right-section">
        <div class="select-instruction">Select at least one row to enable bulk controls</div>
        <mat-form-field class="field bulk-actions">
          <mat-select (selectionChange)="bulkAction($event)" placeholder="Bulk Actions">
            <mat-option [disabled]="!enableBulkButtons" value="csv">Export CSV</mat-option>
            <mat-option [disabled]="!enableBulkButtons" value="details">Export Details</mat-option>
            <mat-option [disabled]="!enableBulkButtons" *ngIf="canPaySites" value="pay">Pay Sites</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <mat-divider class="divider-bottom"></mat-divider>
  </div>

  <div class="table-container">
    <table [dataSource]="dataSource" mat-table aria-describedby="List of Sites">
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th scope="col" *matHeaderCellDef mat-header-cell>
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [aria-label]="checkboxLabel()"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"></mat-checkbox>
        </th>
        <td (click)="$event.stopPropagation()" *matCellDef="let row" class="checkbox-cell" mat-cell>
          <mat-checkbox
            (change)="$event ? selection.toggle(row) : null"
            (click)="$event.stopPropagation()"
            [aria-label]="checkboxLabel(row)"
            [checked]="selection.isSelected(row)"></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="startDate">
        <th scope="col" *matHeaderCellDef mat-header-cell>
          <div>
            <span>Start Date</span>
          </div>
        </th>
        <td *matCellDef="let row" mat-cell>{{ row.startDate }}</td>
      </ng-container>

      <ng-container matColumnDef="endDate">
        <th scope="col" *matHeaderCellDef mat-header-cell>
          <div>
            <span>End Date</span>
          </div>
        </th>
        <td *matCellDef="let row" mat-cell>{{ row.endDate }}</td>
      </ng-container>

      <ng-container matColumnDef="pendingNetPayment">
        <th scope="col" *matHeaderCellDef mat-header-cell>
          <div>
            <span>Pending Payments</span>
          </div>
        </th>
        <td *matCellDef="let row" mat-cell data-cy="pending-payout">
          {{ formatService.formatCurrencyLocal(row.netPendingPayout) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="pendingNetErt">
        <th scope="col" *matHeaderCellDef mat-header-cell>
          <div>
            <span>Pending ERT</span>
          </div>
        </th>
        <td *matCellDef="let row" mat-cell data-cy="pending-ert">
          {{ formatService.formatFourDigits(row.netPendingErt) }}
        </td>
      </ng-container>
      <ng-container matColumnDef="paidNetPayment">
        <th scope="col" *matHeaderCellDef mat-header-cell>
          <div>
            <span>Paid Payments</span>
          </div>
        </th>
        <td *matCellDef="let row" mat-cell data-cy="paid-payout">
          {{ formatService.formatCurrencyLocal(row.netPaidPayout) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="paidNetErt">
        <th scope="col" *matHeaderCellDef mat-header-cell>
          <div>
            <span>Paid ERT</span>
          </div>
        </th>
        <td *matCellDef="let row" mat-cell data-cy="paid-ert">
          {{ formatService.formatFourDigits(row.netPaidErt) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="grossErt">
        <th scope="col" *matHeaderCellDef mat-header-cell>
          <div>
            <span>Gross ERT</span>
          </div>
        </th>
        <td *matCellDef="let row" mat-cell data-cy="gross-ert">
          {{ formatService.formatFourDigits(row.grossErt) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="acrBufferErt">
        <th scope="col" *matHeaderCellDef mat-header-cell>
          <div>
            <span>ACR Buffer</span>
          </div>
        </th>
        <td *matCellDef="let row" mat-cell data-cy="acr-buffer">
          {{ formatService.formatFourDigits(row.acrBufferErt) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="internalBufferErt">
        <th scope="col" *matHeaderCellDef mat-header-cell>
          <div>
            <span>Internal Buffer</span>
          </div>
        </th>
        <td *matCellDef="let row" mat-cell data-cy="internal-buffer">
          {{ formatService.formatFourDigits(row.internalBufferErt) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="deductionErt">
        <th scope="col" *matHeaderCellDef mat-header-cell>
          <div>
            <span>Deduction ERT</span>
          </div>
        </th>
        <td *matCellDef="let row" mat-cell data-cy="deduction-ert">
          {{ formatService.formatFourDigits(row.deductionErt) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="averagePpt">
        <th scope="col" *matHeaderCellDef mat-header-cell>
          <div>
            <span>Average PPT</span>
          </div>
        </th>
        <td *matCellDef="let row" mat-cell data-cy="average-ppt">
          {{ formatService.formatCurrencyLocal(row.averagePpt) }}
        </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns; sticky: true" mat-header-row></tr>
      <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
    </table>
  </div>

  <fc-table-pagination
    [totalPages]="totalPages"
    (goToPage)="goToPage($event)"
    [currentPage]="currentPage"
    [showPages]="showPages"></fc-table-pagination>
</div>
